import script from "./AdminLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLogin.vue?vue&type=script&setup=true&lang=js"

import "./AdminLogin.vue?vue&type=style&index=0&id=714128b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714128b6"]])

export default __exports__